import React from "react";
import styles from "./skeleton.module.css";

type Props = {
  className?: string;
  width: string;
  height: string;
};

export const Skeleton: React.FC<Props> = ({ className, width, height }) => {
  return (
    <div
      className={`${styles.skeleton} ${className ?? ""}`}
      style={{
        width,
        height,
      }}
    />
  );
};
